import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AppDataProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [catalog, setCatalog] = useState(null);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    try {
      const [c, k] = await Promise.all([api.get("/config"), api.get("/catalog")]);
      setConfig(c.data);
      setCatalog(k.data);
    } catch {
      setError(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <Ctx.Provider value={{ config, catalog, error, reload: load }}>{children}</Ctx.Provider>;
}

export const useAppData = () => useContext(Ctx);
